import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateFailureRemediationRequest } from '@/api/generatedApi';
import { GET_ASSET_QUERY_KEY } from '@/hooks/api/assets/useGetAsset';
import { LIST_ASSETS_BY_STATE_QUERY_KEY } from '@/hooks/api/assets/useFetchAssetsByState';
import { ASSET_STATE_COUNTS_QUERY_KEY } from '@/hooks/api/assets/useGetAssetStateCounts';
import { RECENT_FAILURES_QUERY_KEY } from '@/hooks/api/assets/useGetRecentFailures';
import { PART_FINDER_ACTIVITY_QUERY_KEY } from '@/hooks/api/part-finder-activity/query';
import { PART_FINDER_BATCHES_QUERY_KEY, PART_FINDER_BATCH_QUERY_KEY } from '@/hooks/api/part-finder-batches/query';
import { PART_FINDER_REPORTS_QUERY_KEY } from '@/hooks/api/part-finder-reports/query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { FAILURE_REMEDIATION_PLAN_QUERY_KEY } from './useGetFailureRemediationPlan';

const QUERY_KEYS_MOVED_BY_REMEDIATION = [
  RECENT_FAILURES_QUERY_KEY,
  FAILURE_REMEDIATION_PLAN_QUERY_KEY,
  ASSET_STATE_COUNTS_QUERY_KEY,
  LIST_ASSETS_BY_STATE_QUERY_KEY,
  GET_ASSET_QUERY_KEY,
  PART_FINDER_REPORTS_QUERY_KEY,
  PART_FINDER_ACTIVITY_QUERY_KEY,
  PART_FINDER_BATCHES_QUERY_KEY,
  PART_FINDER_BATCH_QUERY_KEY,
];

export function useRemediateFailures() {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();

  return useMutation({
    mutationFn: async (request: CreateFailureRemediationRequest) => {
      const response = await api.failures.createFailureRemediation(getTenantId(), request);
      return response.data;
    },
    onSettled: () => {
      for (const queryKey of QUERY_KEYS_MOVED_BY_REMEDIATION) {
        void queryClient.invalidateQueries({ queryKey: [queryKey] });
      }
    },
  });
}
